<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <div class="px-4 pt-2 pb-2">
                    <PageHeader title="Ventas" icon="fas fa-cash-register" :help="headerHelp">
                        <template v-slot:primary>
                            <v-btn small dark color="primary" @click="dialog = true" v-if="canSell && hasCashRegisterOpened">
                                <v-icon left>fas fa-plus-square</v-icon>{{ $vuetify.breakpoint.xsOnly ? 'Nueva' : 'Nueva venta' }}
                            </v-btn>
                        </template>
                    </PageHeader>
                    <VentaFilters :search.sync="search" :start.sync="datesRange.start" :end.sync="datesRange.end"
                        :client-id.sync="filterClientId" :clients="clientes" :total="totalItems"
                        @search="searchVenta" :advanced.sync="advanced" :catalogs="filterCatalogs"
                        :advanced-count="advancedCount" @open-advanced="drawerFilters = true">
                        <template v-slot:tools>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon :small="!$vuetify.breakpoint.xsOnly" v-bind="attrs" v-on="on" aria-label="Actualizar" @click="reload()">
                                        <v-icon small>fas fa-sync</v-icon>
                                    </v-btn>
                                </template>
                                <span>Actualizar</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon :small="!$vuetify.breakpoint.xsOnly" v-bind="attrs" v-on="on" aria-label="Reporte de ventas" @click="handleExcelExport">
                                        <v-icon small>fas fa-file-export</v-icon>
                                    </v-btn>
                                </template>
                                <span>Reporte de ventas</span>
                            </v-tooltip>
                            <span class="columns-btn-fix"><Columns :headers.sync="headers"></Columns></span>
                        </template>
                    </VentaFilters>
                </div>
                <NoticeBanner v-if="getCashRegisterOpenedByUser.length > 0" tone="warning" icon="fas fa-cash-register"
                    class="mx-4 mb-2" :title="staleCashTitle" :description="staleCashHint">
                    <ul class="stale-cash">
                        <li v-for="cash in getCashRegisterOpenedByUser" :key="cash.id">
                            <strong>{{ cash.sucursal }}</strong>
                            <span>abierta el {{ cash.opened }}</span>
                            <span class="stale-cash__user">{{ cash.user }}</span>
                        </li>
                    </ul>
                    <template v-slot:actions>
                        <v-btn small outlined to="/controlPanel/cashRegister">Ir a cajas</v-btn>
                    </template>
                </NoticeBanner>
                <v-card-text>
                    <v-data-table dense :headers="filteredHeaders" :items="sell" class="elevation-2"
                    :loading="loading" loading-text="Cargando... espera un momento" :options.sync="options"
                    :server-items-length="totalElements" :items-per-page="itemsPerPage"
                    :page.sync="page" @page-count="totalPages = $event"
                    hide-default-footer>
                        <template v-slot:[`item.actions`]="{ item }">
                            <ActionsVenta :item="item" :cancelOut="cancelOut" :canCancel="canCancel" />
                        </template>
                        <template v-slot:[`item.tipoSalida`]="{ item }">
                            <StatusChip :label="item.tipoSalida.nombre" :color="item.tipoSalida.color" />
                        </template>
                        <template v-slot:[`item.ventaEstatus`]="{ item }">
                            <StatusChip v-if="item.ventaEstatus != null" v-bind="ventaStatusChip(item)" />
                        </template>
                        <template v-slot:[`item.tipoPago.formaPago`]= "{ item }">
                            <StatusChip :label="item.tipoPago.formaPago" :tone="pagoTone(item)" outlined />
                        </template>

                        <template v-slot:[`item.saldoNatural`]="{ item }">
                            <span class="text-h7 font-weight-bold" :class="item.saldo > 0 ? 'red--text' : 'green--text'"> {{ item.saldoNatural }} </span>
                        </template>

                        <template v-slot:[`item.eliminado`]="{ item }">
                            <StatusChip :active="!(item.eliminado === true || item.eliminado === 'true')" />
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>
        <VentaFilterDrawer v-model="drawerFilters" :filters="advanced" @apply="advanced = $event"
            :clients="clientes" :sucursales="sucursales" :tipo-salida="tipoSalida" :show-sucursal="canFilterSucursal">
        </VentaFilterDrawer>
        <ModalNuevaVenta :dialog.sync="dialog" :initialize.sync="initialize" :handleModal="handleModal" v-if="dialog"
        :monedas.sync="monedas" :clientes.sync="clientes" :tipoSalida.sync="tipoSalida"
        :tipoPagos.sync="tipoPagos" :sucursales.sync="sucursales"/>
        <ExcelExportVenta :dialog.sync="dialogExcelExport" :handleModal="handleExcelExport"
        :tipo-salida.sync="tipoSalida" :sucursales.sync="sucursales" :clients.sync="clientes"
        :is-admin="isAdmin" show-service-report show-detail-report
        v-if="dialogExcelExport"/>
    </v-row>
</template>
<script>
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import TipoMonedaDataService from '@/service/catalogo/tipoMoneda/tipoMonedaDataService';
import ClienteDataService from '@/service/cliente/clienteDataService';
import TipoSalidaDataService from '@/service/venta/TipoSalidaDataService';
import TipoPagoDataService from '@/service/catalogo/tipoPago/tipoPagoDataService';
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';

import VentaDataService from '@/service/venta/VentaDataService';
import ModalNuevaVenta from "./NuevaVenta.vue";
import ExcelExportVenta from './ExcelExportVenta.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import UsuarioDataService from '@/service/usuario/UsuarioDataService';
import Columns from '@/components/shared/Columns.vue';
import ViewFilesTable from '@/components/shared/ViewFilesTable.vue';
import ActionsVenta from './ActionsVenta.vue';
import PageHeader from '@/components/shared/PageHeader.vue';
import StatusChip from '@/components/shared/StatusChip.vue';
import NoticeBanner from '@/components/shared/NoticeBanner.vue';
import { ventaStatusChip, pagoTone } from '@/utils/ventaStatus';
import VentaFilters from './VentaFilters.vue';
import VentaFilterDrawer from './VentaFilterDrawer.vue';
import { emptyAdvanced, advancedParams, countAdvanced } from './ventaFilters';
import CashRegisterDataService from '@/service/cashRegister/CashRegisterDataService';
import { getToday } from '@/utils/DateUtil';
import { escapeHtml } from '@/helpers/swalHelper';
import { extractMessage } from '@/helpers/errorHelper';
import { can, CAP } from '@/service/permiso/capacidades';

export default {
    name: "ListaVenta",
    mixins: [pagedTableMixin],
    components: { ModalNuevaVenta, PaginationNumber, ExcelExportVenta, Columns, ViewFilesTable, ActionsVenta, PageHeader, StatusChip, NoticeBanner, VentaFilters, VentaFilterDrawer },
    created() {
        this.fetchTableData();
        this.getMoneda();
        this.getAllCliente();
        this.getAllTipoSalida();
        this.getAllTipoPago();
        this.getAllSucursal();
        const userId = this.getUserId;
        this.findCashRegisterOpenedByUser(userId);
    },
    data() {
        return {
            lstCashRegister: [],
            monedas: [],
            clientes: [],
            tipoSalida: [],
            tipoPagos: [],
            sucursales: [],

            headers: [
                { text: "Detalle", value: "actions", sortable: false, groupable: false, show: true },
                { text: "ID", align: " d-none", sortable: false, value: "idVenta", visible: false, groupable: false, show: false },
                { text: 'Sucursal salida', value: 'sucursalEnvia.nombre', groupable: false, show: true },
                { text: 'Sucursal recibe', value: 'sucursalRecibe.nombre', groupable: false, show: true },
                { text: "Folio", value: "ticketFolio", groupable: false, show: true },
                { text: 'Fecha salida', value: 'registerDate', groupable: false, show: true },
                { text: 'Fecha entrega', value: 'deliveryDate', groupable: false, show: true },
                { text: "Cliente", value: "cliente.nombreComercial", groupable: false, show: true },
                { text: 'Tipo salida', value: 'tipoSalida', groupable: false, show: true },
                { text: 'Estatus', value: 'ventaEstatus', groupable: false, show: true },
                { text: "Forma Pago", value: "tipoPago.formaPago", groupable: false, show: true },
                { text: "Total", value: "totalNatural", align: "end", groupable: false, show: true },
                { text: "Saldo", value: "saldoNatural", align: "end", groupable: false, show: true },
                { text: "Abonado", value: "abonadoNatural", align: "end", groupable: false, show: true },
            ],
            datesRange:{ start: getToday().toFormat('yyyy-MM-dd'), end: getToday().toFormat('yyyy-MM-dd') },
            search: "",
            page: 1,
            totalPages: 0,
            itemsPerPage: 25,
            totalElements: 0,
            sell: [],

            // Cliente de la barra de filtros (el del panel lateral va en `advanced`).
            filterClientId: null,
            // Filtros del panel lateral: se aplican de una vez desde el panel.
            advanced: emptyAdvanced(),
            drawerFilters: false,

            dialog: false,
            //Details sell
            dialogExcelExport: false,
        }
    },
    methods: {
        searchVenta() {
            this.doSearch();
        },
        fetchTable(params){
            return VentaDataService.table(params );
        },
        applyRows({ rows, total, totalPages }){
            this.sell = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        handleExcelExport(){
            this.dialogExcelExport = !this.dialogExcelExport
        },
        ventaStatusChip,
        pagoTone,
        handleModal() { this.dialog = !this.dialog; },
        // LOAD CATALOGS
        async getMoneda(){ this.monedas = await TipoMonedaDataService.getAllTipoMoneda().then( resp => resp.data ) || [] },
        async getAllCliente(){ this.clientes = await ClienteDataService.getAll().then( resp => resp.data ) || [] },
        async getAllTipoSalida(){ this.tipoSalida = await TipoSalidaDataService.getAllTipoSalida().then( resp => resp.data ) || [] },
        async getAllTipoPago(){ this.tipoPagos = await TipoPagoDataService.allTipoPago().then( rsp => rsp.data ) || []},
        async getAllSucursal(){ this.sucursales = await SucursalDataService.lstSucursal().then( resp => resp.data ) || [] },

        findCashRegisterOpenedByUser(userId) {
            CashRegisterDataService.findCashRegisterOpenedByUser(userId).then(response => {
                this.lstCashRegister = response.data;
            })
        },
        cancelOut(item){
            if(!this.canCancel){
                this.$swal.fire({ icon: 'error', html: 'No tienes permiso para cancelar ventas', showConfirmButton: false, timer: 3500 });
                return
            }
            // title: `Estas seguro de cancelar el pago \n Folio: ${folio} ? \n Referencia: ${operationNumber} \n Forma de pago: ${paymentMethodNatural} \n Fecha de pago: ${paymentDateNatural} \n Monto pagado: ${payedAmountNatural}`,
            this.$swal.fire({
                title: `¿Está seguro de cancelar la venta \n Folio: ${item.ticketFolio}?`,
                icon: 'warning',
                html: `La venta sera cancelada y no se podra revertir la acción.
                    <br><strong> Cliente: ${escapeHtml(item.cliente?.razonSocial)}</strong>
                    <br><strong> Estatus:</strong> ${escapeHtml(item.ventaEstatus)}
                    <br>Sucursal: ${escapeHtml(item.sucursalEnvia.nombre)} <br> Forma de pago: ${escapeHtml(item.tipoPago.formaPago)}
                    <br><strong>Total:</strong> ${escapeHtml(item.totalNatural)}
                    <br><strong>Saldo:</strong> ${escapeHtml(item.saldoNatural)}
                    <br><strong>Abonado:</strong> ${escapeHtml(item.abonadoNatural)}
                `,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, cancelarla!',
                cancelButtonText: 'No, cancelar!'
            }).then( result => {
                if (result.value) {
                    VentaDataService.cancel(item.id).then(resp => {
                        if( resp.status == 200 ){
                            this.$swal.fire({ icon: 'success', title: 'Venta cancelada', text: resp.data, showConfirmButton: false, timer: 5000 });
                            this.initialize();
                        }
                    }).catch( err => {
                        this.$swal.fire({ icon: 'error', title: 'Error al cancelar la Venta', text: extractMessage(err), showConfirmButton: false, timer: 5000 });
                    })
                }
            }).catch(err => {
                this.$swal.fire({ icon: 'error', text: 'Error al cancelar la venta: ' + extractMessage(err), showConfirmButton: false, timer: 5000 });
            })
        }
    },
    computed:{

        // Filtros dinámicos: el mixin los manda al backend y
        // resetea la página a 1 cuando cambian.
        // Los vacíos van como undefined: axios no los manda y el backend
        // usa sus defaults.
        tableFilters() {
            return {
                startDate: this.datesRange.start,
                endDate: this.datesRange.end,
                ...advancedParams(this.advanced),
                // Después del spread: advancedParams trae su propio clientId (el del panel).
                clientId: this.filterClientId || this.advanced.clientId || undefined
            };
        },
        advancedCount() { return countAdvanced(this.advanced); },
        // Nombres para los chips de los filtros del panel.
        filterCatalogs() {
            return { clientes: this.clientes, sucursales: this.sucursales, tipoSalida: this.tipoSalida };
        },
        headerHelp(){
            return 'Ventas emitidas, con crédito o pagadas. Cada fila es una venta: su saldo baja con los pagos y las notas de crédito.';
        },
        canSell(){
            return can(CAP.VENTA_CREAR, this.roles);
        },
        isAdmin(){ return can(CAP.ADMIN, this.roles); },
        roles(){ return UsuarioDataService.getUserRoles() ?? []; },
        canCancel(){
            return can(CAP.VENTA_CANCELAR, this.roles);
        },
        filteredHeaders(){ return this.headers.filter( h => h.show ); },
        // To validate if the user has cash register opened at least one.
        getUserId() { return UsuarioDataService.getCurrentUser().id; },
        getSucursalId() { return SucursalDataService.getCurrentSucursalId(); },
        hasCashRegisterOpened() {
            if(this.lstCashRegister.length === 0) return false;
            const today = getToday().toFormat('dd/MM/yyyy');
            const cashRegisters = this.lstCashRegister.filter(cashRegister => cashRegister.status === 'OPENED' && cashRegister.opened === today);
            return cashRegisters.length > 0 ;
        },
        getCashRegisterOpenedByUser() {
            if(this.lstCashRegister.length === 0) return [];
            const today = getToday().toFormat('dd/MM/yyyy');
            return this.lstCashRegister.filter(cashRegister => cashRegister.status === 'OPENED' && cashRegister.opened !== today);
        },
        // Quien solo ve su sucursal no necesita filtrar por sucursal.
        canFilterSucursal(){ return can(CAP.SUCURSAL_TODAS_VER, this.roles); },
        staleCashTitle(){
            const count = this.getCashRegisterOpenedByUser.length;
            return count === 1 ? 'Tienes una caja sin cerrar' : `Tienes ${count} cajas sin cerrar`;
        },
        staleCashHint(){
            const pronoun = this.getCashRegisterOpenedByUser.length === 1 ? 'Ciérrala' : 'Ciérralas';
            return `${pronoun} para tener tu caja al día y poder registrar ventas sin pendientes.`;
        }
    }
};
</script>
<style scoped>
/* Cajas abiertas de días anteriores: una fila por caja, sucursal en negritas. */
.stale-cash {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
}
.stale-cash li {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
    padding: 4px 0;
}
.stale-cash li + li {
    border-top: 1px solid var(--app-line);
}
.stale-cash__user {
    color: var(--app-text-muted);
}
/* Columns.vue trae mt-5 ml-2 fijos y un icono grande en primary: dentro de la
   fila de herramientas de la tabla se alinea y se iguala a sus vecinos. */
.columns-btn-fix ::v-deep .v-btn {
    margin: 0 !important;
    color: var(--app-text-muted) !important;
}
.columns-btn-fix ::v-deep .v-btn .v-icon {
    font-size: 16px;
    color: inherit;
}
/* celular: los tres iconos de la tabla llegan a 40px para poder tocarlos */
@media (max-width: 599px) {
    .columns-btn-fix ::v-deep .v-btn {
        width: 40px;
        height: 40px;
    }
}
</style>
